<script lang="ts">
  import { UnsignedMattersState, type LeadUnsignedProps, type UnsignedMatterType, CloseActions, type CloseActionType } from "./LeadUnsigned/UnsignedMattersState.svelte";
  import DpfLeadUnsigned from "./DpfLeadUnsigned.svelte";
  import PcpLeadUnsigned from "./PcpLeadUnsigned.svelte";

  type MatterTypeProps = LeadUnsignedProps & { type: "DpfMatters" | "PcpMatters" };

  let {
    matterTypes = []
  }: {
    matterTypes: MatterTypeProps[]
  } = $props();

  const createState = (
    targetType: "DpfMatters" | "PcpMatters", 
    allowIndividualAskLater: boolean = false,
    nextSignableMatterType: UnsignedMatterType | null = null
  ): UnsignedMattersState | null => {
    const matterType = matterTypes.find(mt => mt.type === targetType);
    if (!matterType) return null;
    
    const unsignedType = targetType.toLowerCase().replace("matters", "") as UnsignedMatterType;
    return new UnsignedMattersState({
      matters: matterType.matters,
      events: matterType.events,
      caseTypePath: matterType.case_type_path,
      matterType: unsignedType,
      nextSignableMatterType,
      allowIndividualAskLater
    });
  };

  // Create PCP state first to check if it exists for DPF's nextSignableMatterType
  const pcpStateManager = createState("PcpMatters", false);
  // DPF points to PCP as next if PCP has actionable matters, otherwise null
  const dpfStateManager = createState("DpfMatters", true, pcpStateManager?.count > 0 ? 'pcp' : null);

  let mountDpf = $state(!!dpfStateManager);
  let mountPcp = $state(!dpfStateManager && !!pcpStateManager);
  let openPcpOnMount = $state(!dpfStateManager);

  const handleDpfClose = (afterCloseAction: CloseActionType) => {
    mountDpf = dpfStateManager.hasActionableMatters();
    if (afterCloseAction !== CloseActions.VIEW_SIGNED) openPcpOnMount = true;
    if (pcpStateManager) mountPcp = true;
  };

  const handlePcpClose = (afterCloseAction: CloseActionType) => {
    mountPcp = pcpStateManager.hasActionableMatters();
  };
</script>

{#if mountDpf}
  <DpfLeadUnsigned manager={dpfStateManager} openOnMount={true} afterClose={handleDpfClose} />
{/if}

{#if mountPcp}
  <PcpLeadUnsigned manager={pcpStateManager} openOnMount={openPcpOnMount} afterClose={handlePcpClose} />
{/if}
